import React from 'react';
import styles from './index.module.less';
const SearchHelp: React.FC<any> = ({ content }) => {
  const showContent = content.contentInfo['section-platform'];
  if (!showContent.title) {
    return null;
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{showContent.title}</h2>
      <p className={styles.desc}>{showContent.desc}</p>
      <div className={styles.cardContainer}>
        <div>
          {showContent.cards.slice(0, 2).map((item: any) => (
            <Card key={item.title} item={item} />
          ))}
        </div>
        <div>
          {showContent.cards.slice(2, 5).map((item: any) => (
            <Card key={item.title} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

const Card: React.FC<any> = ({ item }) => {
  return (
    <div className={styles.card} style={{ backgroundImage: `url(${item.imgPath})` }}>
      <h3 className={styles.cardTitle}>{item.title}</h3>
      <p className={styles.cardDesc}>{item.desc}</p>
    </div>
  );
};

export default SearchHelp;
